import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';

const SearchedRepList = ({ searchedItems, onHandleItemClick }) => {
  const _onHandleItemClick = (item) => () => onHandleItemClick(item);

  return (
    <React.Fragment>
      {searchedItems.size > 0  ? searchedItems.map((item) => (
        <div className={ 'item-search__item' } key={ item.get('id') }
          onClick={ _onHandleItemClick(item) }>
          {`${item.get('name')} - ${item.get('company')}`}
        </div>)
      ) : <div className={ 'item-search__empty' }>
        <div> No results found</div>
      </div>}
    </React.Fragment>
  );
};

SearchedRepList.propTypes = {
  onHandleAddItem:        PropTypes.func,
  onHandleItemClick:      PropTypes.func.isRequired,
  searchedItems:          PropTypes.instanceOf(Immutable.List)
};

export default SearchedRepList;



// WEBPACK FOOTER //
// ./app/components/shared/search/SearchedRepList.jsx